// extracted by mini-css-extract-plugin
export default {"username":"PXfFhsq","popover":"ui7lBKF","chevronIcon":"tb+Bt8S","chevronIcon__open":"GNfBBoK"};